import React, { useState } from 'react';
import { Button, Icon } from '@material-ui/core';
import { useStyles } from '../styles';
import EditTimelineModal from './EditTimelineModal';


const EditTimelineButton = ({
  series
}) => {
  const classes = useStyles();
  const [isOpenModal, setOpenModal] = useState<boolean>(false);
  return (
    <>
      <Button
        variant="outlined"
        className={`${classes.quoteSummaryCTAButton} mr-2 items-center bg-white px-6`}
        onClick={() => setOpenModal(true)}
      >
        <Icon className="mr-2 text-16 mb-1">calendar_today</Icon>
        <span>{'Edit Timeline'}</span>
      </Button>
      <EditTimelineModal
        open={isOpenModal}
        setOpen={setOpenModal}
        series={series}
      />
    </>
  );
};

export default EditTimelineButton;
